import createReducer from '../utils/createReducer';
import actions from '../actions/accountCreation';
import {validateEmail, validatePassword, checkCreateAccountBtnStatus, validatePhoneNumber} from '../utils/validate';

const initialState = {};

const actionHandlers = {

    [actions.SET_FIRST_NAME](state, {payload}) {
        return {
            ...state,
            firstName: payload.fieldVal
        };
    },

    [actions.SET_LAST_NAME](state, {payload}) {
        return {
            ...state,
            lastName: payload.fieldVal
        };
    },

    [actions.SET_DIALING_COUNTRY_CODE](state, {payload}) {
        return {
            ...state,
            dialingCountryCode: payload.fieldVal
        };
    },

    [actions.SET_COUNTRY_DIALING_NUMBER](state, {payload}) {
        return {
            ...state,
            countryDialingNumber: payload.fieldVal
        };
    },

    [actions.SET_PHONE_NUMBER](state, {payload}) {
        return {
            ...state,
            phoneNumber: payload.fieldVal
        };
    },

    [actions.SET_COMPANY_NAME](state, {payload}) {
        return {
            ...state,
            companyName: payload.fieldVal
        };
    },

    [actions.SET_EMAIL](state, {payload}) {
        return {
            ...state,
            email: payload.fieldVal
        };
    },

    [actions.SET_PASSWORD](state, {payload}) {
        return {
            ...state,
            password: payload.fieldVal
        };
    },

    [actions.SET_PASSWORD_TYPE](state, {payload}) {
        return {
            ...state,
            passwordFieldType: payload.fieldVal
        };
    },

    [actions.SET_PASSWORD_NOTIFICATIONS](state, {payload}) {
        return {
            ...state,
            passwordNotify: payload.fieldVal
        };
    },

    [actions.SET_FIELD_ERROR](state, {payload}) {
        if (payload.field === 'firstName') {
            return {
                ...state,
                firstNameError: payload.msg
            };
        } else if (payload.field === 'lastName') {
            return {
                ...state,
                lastNameError: payload.msg
            };
        } else if (payload.field === 'phoneNumber') {
            return {
                ...state,
                phoneNumberError: payload.msg
            };
        } else if (payload.field === 'companyName') {
            return {
                ...state,
                companyNameError: payload.msg
            };
        } else if (payload.field === 'email') {
            return {
                ...state,
                emailError: payload.msg
            };
        } else if (payload.field === 'password') {
            return {
                ...state,
                passwordError: payload.msg
            };
        }

        return {
            ...state
        };
    },

    [actions.VALIDATE_FIRST_NAME](state, {payload}) {
        const firstName = payload.fieldVal.trim()
        if (!firstName) {
            return {
                ...state,
                firstNameError: 'ipmob.input.field.required',
                enableCreateAccountButton: false
            };
        }
        return {
            ...state
        };
    },

    [actions.VALIDATE_LAST_NAME](state, {payload}) {
        const lastName = payload.fieldVal.trim()
        if (!lastName) {
            return {
                ...state,
                lastNameError: 'ipmob.input.field.required',
                enableCreateAccountButton: false
            };
        }
        return {
            ...state
        };
    },

    [actions.VALIDATE_COMPANY_NAME](state, {payload}) {
        const companyName = payload.fieldVal.trim()
        if (!companyName) {
            return {
                ...state,
                companyNameError: 'ipmob.input.field.required',
                enableCreateAccountButton: false
            };
        }
        return {
            ...state
        };
    },

    [actions.VALIDATE_EMAIL](state, {payload}) {
        const isValidEmailAddress = validateEmail(payload.fieldVal);
        if (!isValidEmailAddress) {
            return {
                ...state,
                emailError: 'ipmob.create_account.button.text_5',
                enableCreateAccountButton: false
            };
        }
        return {
            ...state
        };
    },

    [actions.VALIDATE_PASSWORD](state, {payload}) {
        const isValidPassword = validatePassword(payload.fieldVal);
        if (!isValidPassword) {
            return {
                ...state,
                passwordError: 'ipmob.create_account.button.text_4',
                enableCreateAccountButton: false
            };
        } else if (payload.fieldVal.includes(state.email, 0)) {
            return {
                ...state,
                serviceError: 'ipmob.create_account.button.text_6',
                enableCreateAccountButton: false
            };
        }
        return {
            ...state
        };
    },

    [actions.VALIDATE_PHONE](state, {payload}) {
        const isValidPhone = validatePhoneNumber(payload.fieldVal, state.countryDialingNumber);
        if (!isValidPhone) {
            return {
                ...state,
                phoneNumberError: 'ipmob.help_page.error_msg_3',
                enableCreateAccountButton: false
            };
        }
        return {
            ...state
        };
    },

    [actions.CREATE_ACCOUNT_SERVICE_ERROR](state, {payload}) {
        return {
            ...state,
            serviceError: payload.errorKey,
            accountExistsError: ''
        };
    },

    [actions.ACCOUNT_CONFLICT_WARNING](state, {payload}) {
        return {
            ...state,
            accountExistsError: payload.errorKey,
            serviceError: ''
        };
    },

    [actions.TOGGLE_AC_CONTINUE_BUTTON](state, {}) {
        const enableCreateAccountButton = checkCreateAccountBtnStatus(state);
        return {
            ...state,
            enableCreateAccountButton
        };
    },

    [actions.PRE_POPULATE_BASIC_INFO](state, {payload}) {
        const {firstName, lastName} = payload.brandSwitchParams;

        return {
            ...state,
            firstName,
            lastName
        };
    }
};

export default createReducer(actionHandlers, initialState);
